import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import {
  ManufacturerArticleLot,
  ManufacturerCertificate,
  ManufacturerRangeSelection,
} from './check-order-manufacturer.models';
import { DTO } from 'src/app/models/supplier-portal/supplier/supplierDTOS.models';
import { OrderProcessingService } from 'src/app/services/portal-supplier/order-processing.service';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';
import { CheckOrderCertificatesComponent } from './check-order-certificates/check-order-certificates.component';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';
type ManufacturerCheckStep = 1 | 2 | 3 | 4 | 5 | 6;

@Component({
  selector: 'app-check-order-manufacturer',
  standalone: false,
  templateUrl: './check-order-manufacturer.component.html',
  styleUrls: ['./check-order-manufacturer.component.scss'],
})
export class CheckOrderManufacturerComponent implements OnInit {
  @ViewChild('ddtFileInput')
  private ddtFileInput?: ElementRef<HTMLInputElement>;
  @ViewChild(CheckOrderCertificatesComponent, { static: false })
  addFileComponent!: CheckOrderCertificatesComponent;

  public productsFromOrder: ProcessingOrders.IProductInOrder[] = [];
  public newBatchToUpload: Partial<ProcessingOrders.IProductBatch> = {
    documents: [],
    batch_year: new Date().getFullYear(),
  };
  public disableContinue: boolean = false;
  public certificates: ManufacturerCertificate[] = [];
  public readonly rangeSelection: ManufacturerRangeSelection | null = null;
  public readonly articleLots: Record<number, ManufacturerArticleLot[]> = {};

  public readonly orderCode: string;
  public activeStep: ManufacturerCheckStep = 1;
  public selectedArticleCode: number = -1;
  // selectedProduct: ProcessingOrders.IProductInOrder | null = null;
  // selectedBatch: ProcessingOrders.IProductBatch | null = null;
  public processedArticleCodes: number[] = [];
  public orderCompleted = false;
  public openedLotsArticleCode: number | null = null;
  private orderServ = inject(OrderProcessingService);
  public orderToProcess: ProcessingOrders.Certification | null = null;
  public loading = false;
  currentYear = new Date().getFullYear();
  private orderService = inject(OrderHelperService);
  public mServ = inject(ManufacturerPopoversService);
  private readonly router = inject(Router);

  public constructor(
    private readonly route: ActivatedRoute,
  ) {
    this.orderCode = this.route.snapshot.paramMap.get('id') ?? '';
  }

  ngOnInit(): void {
    this.getOrderToProcess();
  }

  public get pageTitle(): string {
    if (!this.orderToProcess) {
      return 'Processo ordine';
    }

    return this.orderToProcess.order_number
      ? `Processo ordine n°${this.orderToProcess.order_number}`
      : 'Processo ordine';
  }

  private cdr = inject(ChangeDetectorRef);
  private ngZone = inject(NgZone);
  getOrderToProcess(addedDocument: boolean = false) {
    this.loading = true;

    if (!this.orderCode) {
      this.loading = false;
      return;
    }

    this.orderServ.getCertificationByID(+this.orderCode).subscribe({
      next: (response) => {
        console.log('Order to process response', response);

        this.ngZone.run(() => {
          this.orderToProcess = response;
          this.productsFromOrder = response?.products ?? [];
          this.orderService.ddtDate.next(this.orderToProcess.ddt_date);
          this.loading = false;
          if (this.checkFinished && !addedDocument) {
            this.selectedArticleCode = -1;
            this.activeStep = 5;
          } else if (!addedDocument) {
            this.activeStep = 1;
          }
          console.log('orderToProcess after assign', this.orderToProcess);
          this.cdr.detectChanges();
          if (addedDocument) this.addDocument();
        });
      },
      error: (err) => {
        console.error(err);

        this.ngZone.run(() => {
          this.loading = false;
          this.cdr.detectChanges();
        });
      },
    });
  }

  public get selectorLabel(): string {
    if (this.isViewingArticleLots) {
      return 'Scegli articolo';
    }

    switch (this.activeStep) {
      case 1:
        return 'Scegli codice articolo';
      case 2:
        return 'Specifica periodo e range';
      case 3:
        return 'Carica certificati materiali';
      case 6:
      case 4:
        return 'Processa codice articolo';
      case 5:
        return this.orderCompleted
          ? 'Ordine completato!'
          : 'Processa codice articolo';
      default:
        return 'Scegli codice articolo';
    }
  }

  public get selectorValue(): string {
    // if (this.activeStep === 1) {
    //   const orderNumber = this.orderToProcess?.order_number;

    //   return orderNumber ? `Ordine "${orderNumber}"` : 'Ordine';
    // }

    if (this.isViewingArticleLots) {
      return (
        `${this.productToWorkOn?.product_description} - ${this.productToWorkOn?.product_code}` ||
        'Nessun articolo selezionato'
      );
    }

    return this.productToWorkOn?.product_code
      ? `${this.productToWorkOn?.product_description} - ${this.productToWorkOn?.product_code}`
      : 'Nessun articolo selezionato';
  }

  public get selectorTone(): 'default' | 'success' {
    return this.orderCompleted && !this.isViewingArticleLots
      ? 'success'
      : 'default';
  }

  public get visibleProcessedArticleCodes(): number[] {
    return this.orderCompleted
      ? this.productsFromOrder.map(
        (article) => article.supplier_certificate_product_id,
      )
      : this.processedArticleCodes;
  }

  public get productToWorkOn(): ProcessingOrders.IProductInOrder | null {
    // return this.selectedProduct;
    return this.orderService.selectedProduct.value;
  }

  public get isViewingArticleLots(): boolean {
    return this.activeStep === 5 && this.openedLotsArticleCode !== null;
  }

  public get selectedArticleLots(): ManufacturerArticleLot[] {
    if (!this.openedLotsArticleCode) {
      return [];
    }

    return this.articleLots[this.openedLotsArticleCode] ?? [];
  }

  public get showBackAction(): boolean {
    return (
      this.isViewingArticleLots || !this.orderCompleted || this.activeStep !== 5
    );
  }

  public selectArticle(product: ProcessingOrders.IProductInOrder): void {
    const code = product?.supplier_certificate_product_id ?? -1;

    console.log('Selected article code', code);
    if (!product || !code) {
      return;
    }
    console.log('what product was selected ', product);
    this.orderService.selectedProduct.next(product);
    // this.selectedProduct = product;
    this.cdr.detectChanges();
    if (
      this.activeStep === 5 &&
      this.visibleProcessedArticleCodes.includes(code)
    ) {
      this.openArticleLots(code);
      return;
    }

    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
  }

  public batchSelected(product: ProcessingOrders.IProductBatch): void {
    // this.selectedBatch = product;
    this.orderService.selectedBatch.next(product);
    this.orderService.selectedDocuments.next(product?.documents);
  }

  public addLot(code: number): void {
    if (!code) {
      return;
    }
    this.orderService.selectedBatch.next(null);

    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
    this.newBatchToUpload = {
      documents: [],
      batch_year: new Date().getFullYear(),
    };
    this.activeStep = 2;
  }

  goToList(isGoing: boolean) {
    console.log('isGoing ', isGoing);

    if (isGoing) {
      this.getOrderToProcess();
      this.activeStep = 1;
    } else {
      this.activeStep = 4;
    }
  }

  public async continueFromRange() {
    if (!this.orderService.selectedProduct.value || !this.productToWorkOn) {
      return;
    }

    const isManualLot = this.productToWorkOn.is_manual_lot;
    let qta: number;

    if (isManualLot) {
      const manualBatch = this.newBatchToUpload?.manual_batch?.trim();

      if (!manualBatch) {
        this.mServ.errorSwal('Il lotto inserito non è valido.');
        return;
      }

      qta = this.newBatchToUpload?.qta ?? 0;

      if (qta <= 0) {
        this.mServ.errorSwal('La quantità inserita deve essere maggiore di zero.');
        return;
      }

      const rQty =
        +this.orderService.getRemainingQtyDuplicates +
        this.orderService.batchQty -
        qta;

      if (rQty > 0) {
        await this.mServ.showQtyVariation(
          'Hai aggiunto una quantità inferiore a quella disponibile',
        );
      } else if (rQty < 0) {
        await this.mServ.showQtyVariation(
          'Hai aggiunto una quantità maggiore di quella disponibile',
        );
      }
    } else {
      const serialFrom = this.newBatchToUpload?.serial_from ?? 0;
      const serialTo = this.newBatchToUpload?.serial_to ?? 0;
      qta = serialTo - serialFrom + 1;

      if (qta <= 0 || serialFrom > serialTo) {
        this.mServ.errorSwal('Il range inserito non è valido: il valore "Da" deve essere inferiore o uguale ad "A".');
        return;
      }

      if ((this.newBatchToUpload?.qta ?? 0) <= 0) {
        this.mServ.errorSwal('La quantità inserita deve essere maggiore di zero.');
        return;
      }

      const rQty =
        +this.orderService.getRemainingQtyDuplicates +
        this.orderService.batchQty -
        qta;

      if (rQty > 0) {
        const answer = await this.mServ.showQtyVariation(
          'Hai aggiunto una quantità inferiore a quella disponibile',
        );
      } else if (rQty < 0) {
        const answer = await this.mServ.showQtyVariation(
          'Hai aggiunto una quantità maggiore di quella disponibile',
        );
      }
    }

    const payload: ProcessingOrders.IBatchToAdd = {
      certification_product_id:
        this.orderService.selectedProduct.value
          ?.supplier_certificate_product_id ?? 0,

      supplier_certificate_batch_id:
        this.newBatchToUpload.supplier_certificate_batch_id ?? 0,
      certification_batch_id:
        this.newBatchToUpload.supplier_certificate_batch_id ?? 0,
      batch_year: this.newBatchToUpload.batch_year ?? 0,
      batch_week: this.newBatchToUpload.batch_week ?? 0,
      serial_from: this.newBatchToUpload.serial_from ?? 0,
      serial_to: this.newBatchToUpload.serial_to ?? 0,
      manual_batch: isManualLot ? this.newBatchToUpload.manual_batch : undefined,
      qta,
    };
    this.orderServ.putCertificationBatch(payload).subscribe({
      next: (response) => {
        this.ngZone.run(() => {
          if (!response || response instanceof HttpErrorResponse) {
            this.mServ.errorSwal("Errore durante l'aggiunta del lotto.");
            return;
          }

          const requestSucceeded =
            !('success' in response) || response.success === true;

          console.log('response after adding batch ', response);

          if (!requestSucceeded) {
            const errorMsg = ('error_message' in response)
              ? (response.error_message as { msg_code?: number; msg_type?: string } | null)
              : null;
            const errorMessage = errorMsg?.msg_code === 27
              ? (errorMsg.msg_type ?? "Errore durante l'aggiunta del lotto.")
              : "Errore durante l'aggiunta del lotto.";
            this.mServ.errorSwal(errorMessage);
            return;
          }

          const createdBatchId =
            'data' in response
              ? Number(
                (
                  response.data as {
                    result_id?: number;
                  } | null
                )?.result_id ?? 0,
              )
              : (response.supplier_certificate_batch_id ?? 0);
          // this.newBatchToUpload?.supplier_certificate_batch_id ?? 0;

          if (!createdBatchId) {
            this.mServ.errorSwal("Errore durante l'aggiunta del lotto.");
            return;
          }

          const createdBatch: ProcessingOrders.IProductBatch = {
            supplier_certificate_batch_id: createdBatchId,
            certification_id:
              this.orderService.selectedProduct.value
                ?.supplier_certificate_product_id,
            // certification_batch_id: createdBatchId,
            batch_year: payload.batch_year,
            batch_week: payload.batch_week,
            serial_from: payload.serial_from,
            serial_to: payload.serial_to,
            manual_batch: payload.manual_batch ?? '',
            qta: payload.qta,
            documents:
              createdBatchId == 0 ? [] : this.newBatchToUpload.documents,
          };
          if (createdBatch.documents.length == 0) {
            this.activeStep = 3;
          } else {
            this.activeStep = 4;
          }
          let answer = this.productToWorkOn!.batches.find(
            (b) => b.supplier_certificate_batch_id == createdBatchId,
          );
          if (answer) {
            Object.assign(answer, createdBatch);
            console.log('is answer ', answer);
            this.orderService.selectedProduct.next(this.productToWorkOn);
          } else {
            this.productToWorkOn!.batches = [
              ...(this.productToWorkOn!.batches ?? []),
              createdBatch,
            ];
          }
          console.log('is this.productToWorkOn ', this.productToWorkOn);
          console.log('is createdBatch ', createdBatch);
          this.newBatchToUpload = createdBatch;
          this.orderService.selectedBatch.next(createdBatch);
          this.orderService.selectedDocuments.next(createdBatch?.documents);
          this.mServ.successSwal('Lotto aggiunto con successo.');

          this.cdr.detectChanges();
        });
      },
      error: () => {
        this.mServ.errorSwal("Errore durante l'aggiunta del lotto.");
        return;
      },
    });
  }

  public saveUploadedCertificates(): void {
    if (!this.selectedArticleCode) {
      return;
    }

    this.activeStep = 4;
  }

  public removeCertificate(code: number): void {
    this.orderServ.deleteCertificationFile(code).subscribe({
      next: async (response: any) => {
        if (!response || response instanceof HttpErrorResponse) {
          this.mServ.errorSwal('Errore durante la rimozione del certificato.');
          return;
        }

        const requestSucceeded =
          !('success' in response) || response.success === true;

        if (!requestSucceeded) {
          this.mServ.errorSwal('Errore durante la rimozione del certificato.');
          return;
        }
        const list =
          this.orderService.selectedDocuments.value?.filter(
            (doc: ProcessingOrders.IProductBatchDocument) =>
              doc.supplier_certificate_document_id !== code,
          ) ?? [];
        this.orderService.selectedDocuments.next(list);

        // const isConfirm = await this.popoverServ.goToDocumentsList();
      },
      error: () => {
        this.mServ.errorSwal('Errore durante la rimozione del certificato.');
      },
    });
  }

  public addCertificate(code: boolean): void {
    if (!code) return;
    this.getOrderToProcess(true);
  }

  public addDocument() {
    const product = this.productsFromOrder.find(
      (p) =>
        p.supplier_certificate_product_id ===
        this.orderService.selectedProduct.value?.supplier_certificate_product_id,
    );
    this.orderService.selectedProduct.next(product);
    console.log('is product ', product);
    const batch = product?.batches.find(
      (b) =>
        b.supplier_certificate_batch_id ===
        this.orderService.selectedBatch.value?.supplier_certificate_batch_id,
    );
    console.log('batch ', batch);
    this.orderService.selectedBatch.next(batch);
    this.orderService.selectedDocuments.next(batch?.documents);
  }

  get checkFinished() {
    return this.productsFromOrder.some((p) => p?.is_prepared); //for some products to create the partial
    //return this.productsFromOrder.every(p => p.is_prepared) // for all products to be present in order
  }

  public saveCertificates(): void {
    if (!this.selectedArticleCode) {
      return;
    }
    this.getOrderToProcess();
    // if (this.checkFinished) {
    //   this.openArticleLots(this.selectedArticleCode);
    //   this.activeStep = 5;
    // }
    // else {
    //   this.activeStep = 1;
    // }
  }

  public elaborateLot(code: number): void {
    console.log('well well well 1');
    if (!code) {
      return;
    }

    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
    this.activeStep = 6;
  }

  public elaborateCustomRange(code: number): void {
    console.log('well well well 2', code);
    if (!code) {
      return;
    }
    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
    this.newBatchToUpload = this.orderService.selectedBatch.value;
    this.orderCompleted = false;
    this.activeStep = 2;
  }

  public prepareAnotherArticle(code: number): void {
    if (!code) {
      return;
    }

    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
    this.newBatchToUpload = {
      documents: [],
      batch_year: new Date().getFullYear(),
    };
    this.orderCompleted = false;
    this.activeStep = 2;
  }

  public async confirmOrder(id: number, code: string) {
    if (!id) {
      return;
    }
    const isApproved = await this.mServ.approveOrder();
    if (!isApproved) return;

    const isAllowed = await this.mServ.completeOrder(code);

    if (!isAllowed) return;

    this.orderServ.closeCertification(id).subscribe({
      next: async (response: any) => {
        if (!response || response instanceof HttpErrorResponse) {
          this.mServ.errorSwal(
            "Errore durante la rimozione dell'ordine completato",
          );
          return;
        }

        const requestSucceeded =
          !('success' in response) || response.success === true;

        if (!requestSucceeded) {
          this.mServ.errorSwal(
            "Errore durante la rimozione dell'ordine completato",
          );
          return;
        }

        this.mServ.successSwal('Ordine completato con successo.');

        this.openedLotsArticleCode = null;
        this.orderCompleted = true;
        this.router.navigate(['/dashboard']);

        return;
        // const isConfirm = await this.popoverServ.goToDocumentsList();
      },
      error: () => {
        this.mServ.errorSwal(
          "Errore durante la rimozione dell'ordine completato",
        );
      },
    });
  }

  public uploadDdt(): void {
    const fileInput = this.ddtFileInput?.nativeElement;

    if (!fileInput) {
      return;
    }

    fileInput.value = '';
    fileInput.click();
  }

  public onDdtSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const fileContent = reader.result?.toString() ?? '';
      const base64Content = fileContent.includes(',')
        ? fileContent.split(',')[1]
        : fileContent;

      const documentToAdd = {
        certification_id: this.orderToProcess?.supplier_certificate_id,
        ddt_file: base64Content,
        ddt_file_name: file.name,
      };

      this.orderServ.putCertificationDDT(documentToAdd).subscribe({
        next: async (response) => {
          if (!response || response instanceof HttpErrorResponse) {
            this.mServ.errorSwal(
              'Errore durante il caricamento del certificato.',
            );
            return;
          }

          const requestSucceeded =
            !('success' in response) || response.success === true;

          if (!requestSucceeded) {
            this.mServ.errorSwal(
              'Errore durante il caricamento del certificato.',
            );
            return;
          }
          this.mServ.successSwal('DDT caricato con successo.');
          this.getOrderToProcess();
        },
        error: () => {
          this.mServ.errorSwal(
            'Errore durante il caricamento del certificato.',
          );
        },
      });
    };

    reader.onerror = () => {
      this.mServ.errorSwal('Impossibile leggere il file selezionato.');
    };

    reader.readAsDataURL(file);
    input.value = '';
  }

  public async removeDDT(code: number) {
    const isAllowed = await this.mServ.askForDDTDelete();

    if (!isAllowed) return;

    this.orderServ.deleteCertificationDDT(code).subscribe({
      next: async (response: any) => {
        if (!response || response instanceof HttpErrorResponse) {
          this.mServ.errorSwal('Errore durante la rimozione del DDT.');
          return;
        }

        const requestSucceeded =
          !('success' in response) || response.success === true;

        if (!requestSucceeded) {
          this.mServ.errorSwal('Errore durante la rimozione del DDT.');
          return;
        }
        this.mServ.successSwal('Rimozione del DDT avvenuta con successo.');
        this.getOrderToProcess();

        // const isConfirm = await this.popoverServ.goToDocumentsList();
      },
      error: () => {
        this.mServ.errorSwal('Errore durante la rimozione del DDT.');
      },
    });
  }

  public back(): void {
    if (this.isViewingArticleLots) {
      this.openedLotsArticleCode = null;
      return;
    }

    if (this.orderCompleted) {
      this.orderCompleted = false;
      return;
    }

    // if (this.activeStep == 6) {
    //   this.activeStep = 5;
    // }

    if (this.activeStep == 5) {
      this.router.navigate(['/dashboard']);
      return;
    }

    if (this.activeStep > 1) {
      this.activeStep = (this.activeStep - 1) as ManufacturerCheckStep;
      return;
    }

    const tab = history.state?.['returnTab'] ?? 'inProgress';
    const base = this.router.url.startsWith('/manufacturer-list') ? 'manufacturer-list' : 'dashboard';
    void this.router.navigate([`/${base}`], { state: { tab } });
  }

  private openArticleLots(code: number): void {
    this.selectedArticleCode = code;
    this.openedLotsArticleCode = code;
  }

  uploadCertificate() {
    console.log('this.addFileComponent ', this.addFileComponent);
    this.addFileComponent?.uploadCertificate();
  }
  get getConfirm(): boolean {
    const hasDdt = this.orderToProcess?.ddt_url != null && this.orderToProcess?.ddt_url !== '';
    const hasDocuments = this.productsFromOrder.some(
      (p) => p.batches?.some((b) => Array.isArray(b.documents) && b.documents.length > 0),
    );
    return hasDdt && hasDocuments;
  }
}
